import React from 'react';

// ═══════════════════════════════════════════════════════════════════════════
// Pictos des cartes du Planning.
//
// Extrait de `PlanningAtelier.js` pour que la recherche globale
// (`RechercheDossier.js`) montre EXACTEMENT les mêmes drapeaux que la grille :
// un résultat de recherche doit être reconnaissable comme la carte qu'on
// retrouvera à l'écran. Le réimporter depuis `PlanningAtelier.js` aurait créé
// un cycle d'imports, et le recopier aurait garanti la divergence.
//
// Traits simples plutôt qu'emojis : la couleur vient de `currentColor` (donc de
// la pastille parente), le fond reste transparent. Même convention que les
// icônes Import/Export du CRM.
// ═══════════════════════════════════════════════════════════════════════════

const TRAITS = {
  // Planification complémentaire : deux flèches en cycle
  complement: <><path d="M3 8a5 5 0 0 1 8.5-3.5L13 6" /><path d="M13 8a5 5 0 0 1-8.5 3.5L3 10" /><path d="M13 3v3h-3" /><path d="M3 13v-3h3" /></>,
  // Pièces : carton
  pieces: <><path d="M2.5 5.5 8 3l5.5 2.5v5L8 13l-5.5-2.5z" /><path d="M2.5 5.5 8 8l5.5-2.5" /><path d="M8 8v5" /></>,
  // Téléphone manquant : combiné barré
  tel: <><path d="M4 3.5c.5 2 1.5 3.5 3 5s3 2.5 5 3l-1.5 1.5c-3-.5-6.5-4-7-7z" /><path d="M2.5 13.5 13.5 2.5" /></>,
  // Client sur place : horloge
  attend: <><circle cx="8" cy="8" r="5.5" /><path d="M8 4.8V8l2.2 1.4" /></>,
  // Demande client en cours : bulle de discussion
  demande: <path d="M13.5 7.6a5 5 0 0 1-5.4 5 5.3 5.3 0 0 1-2-.4L3 13l1.1-2.7a5 5 0 0 1-.8-2.7 5.1 5.1 0 0 1 5.1-5.1 5 5 0 0 1 5.1 5.1z" />,
  // Photos présentes sur le dossier : appareil photo
  photos: <><path d="M2 5.5h2.6L5.8 4h4.4l1.2 1.5H14v7H2z" /><circle cx="8" cy="9" r="2.3" /></>,
  // Prépicking fait : chariot de magasin. ⚠️ Volontairement d'une FORME très
  // différente du carton « Pièces » : les deux voisinent sur la carte, et le
  // picto Pièces se met au vert à tort sur des dossiers sans commande. Deux
  // pastilles vertes de forme proche, dont une menteuse, seraient pires que
  // pas de picto du tout.
  prepicking: <><path d="M1.5 2.5h1.8l1.9 7h6.4l1.4-4.6H4.4" /><circle cx="6" cy="12.5" r="1.2" /><circle cx="11" cy="12.5" r="1.2" /></>,
  // (La courtoisie n'est plus dessinée en traits : elle est repassée à l'emoji 🚗
  //  ci-dessous — une voiture ne se reconnaît pas à 11 px en trait blanc.)
};

export default function CardFlagIcon({ type, taille = 11 }) {
  if (type === 'roole') return <span className="card-flag-lettre">R</span>;
  // Courtoisie : l'emoji est REVENU (retour utilisateur 2026-08-06). Une voiture
  // réduite à un trait blanc de 11 px ne se reconnaissait pas — c'est la seule
  // forme du lot qui a besoin de son détail pour être lue d'un coup d'œil.
  if (type === 'courtoisie') return <span className="card-flag-emoji">🚗</span>;
  // Parking : le 🅿️ de Gestion Parking est un carre bleu a P blanc. Rendu en
  // emoji, il gardait ses propres marges et flottait au milieu de la pastille.
  // Repris ici comme le picto Roole — une LETTRE pleine sur pastille coloree —
  // il occupe toute la surface tout en restant le meme symbole a l'oeil.
  if (type === 'parking') return <span className="card-flag-lettre">P</span>;
  return (
    // Trait épaissi (1,7) : il est BLANC sur une pastille de couleur, et un filet
    // de 1,2 px s'y noyait. `taille` permet de réutiliser le même dessin en grand
    // format dans le panneau Réception.
    <svg viewBox="0 0 16 16" width={taille} height={taille} fill="none"
      stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true">
      {TRAITS[type]}
    </svg>
  );
}
